import { useMutation } from '@apollo/client';
import { message } from 'antd';
import { useCallback, useContext, useEffect } from 'react';
import { AppContext } from '../../AppContext';
import { ROUTES } from '../../common/constants';
import LoaderComponent from '../../components/LoaderComponent';
import useRouter from '../../hooks/useRouter';
import { AppContextType } from '../../types/appContext.type';
import { REFRESH_TOKEN } from './graphql/mutations';

const RefreshToken = () => {
  const { initializeAuth, getRefreshToken } = useContext(
    AppContext,
  ) as AppContextType;
  const {
    navigate,
    location: { state },
  } = useRouter();
  const refreshToken = getRefreshToken();

  const handleAuthError = useCallback(() => {
    localStorage.clear();
    navigate(ROUTES.LOGIN, { replace: true });
    message.error('Session expired. Please log in again.');
  }, [navigate]);

  const [refresh, { loading }] = useMutation(REFRESH_TOKEN, {
    fetchPolicy: 'network-only',
    onCompleted: (response) => {
      const accessToken = response?.refreshTokenWeb?.accessToken ?? null;
      if (accessToken) {
        initializeAuth(accessToken, null);
        navigate(state?.from || ROUTES.MAIN, { replace: true });
      } else {
        handleAuthError();
      }
    },
    onError: handleAuthError,
  });

  useEffect(() => {
    if (refreshToken) {
      refresh({ variables: { data: { refreshToken } } });
    }
  }, [refreshToken, refresh]);

  return loading ? <LoaderComponent /> : null;
};

export default RefreshToken;
